module.exports = __webpack_public_path__ + "img/9_74.a7d127a8.png";